<template>
  <div class="redeem">
    <el-dialog
      class="redeem_dialog"
      title="美团挂号核销"
      :visible.sync="redeemMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" :model="redeemMap.form" :rules="redeemMap.rules" label-width="0px" @submit.native.prevent>
          <el-form-item class="form_item form_item_code" label="" required>
            <el-input class="form_input" placeholder="输入券码或扫描二维码" v-model.trim="redeemMap.form.voucherCode">
              <div slot="append" :class="{'form_input_btn': true, 'can_click': ![null, undefined, ''].includes(redeemMap.form.voucherCode)}" @click="redeemCode">验券</div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      class="redeem_confirm_dialog"
      title="确认验券"
      :visible.sync="confirmMap.visible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="confirmClose">
      <div class="confirm_content">
        <div class="confirm_tips">
          <span class="el-icon-info confirm_tips_icon"></span>
          <span class="confirm_tips_text">请您核对用户的消费项目</span>
        </div>
        <div class="confirm_info">
          <div class="confirm_title">团购｜{{ confirmMap.name }}</div>
        </div>
      </div>
      <div slot="footer" class="confirm_footer">
        <el-button @click="confirmClose">取 消</el-button>
        <el-button type="primary" @click="confirmSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { imgArr } from '@/assets/images/img'
  import { debounce } from '@/utils/validateBase'
  import req from '@/utils/request'

  export default {
    name: 'registerMeiTuanRedeem',
    data() {
      return {
        imgArr: imgArr,
        loading: false,
        redeemMap: {
          visible: false,
          form: {
            registeredId: '',
            plat: 1,
            voucherCode: ''
          },
          rules: {}
        },
        confirmMap: {
          visible: false,
          name: ''
        }
      }
    },
    methods: {
      open (id) {
        this.redeemMap.form.registeredId = id
        this.redeemMap.visible = true

        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      },
      close () {
        this.redeemMap.visible = false

        this.redeemMap.form.registeredId = ''
        this.redeemMap.form.voucherCode = ''
      },
      async redeemCode () {
        if (!this.redeemMap.form.voucherCode) {
          this.$message.error('请输入券码')
          return
        } else {
          this.loading = true
          const res = await req.post('/physio/group-voucher/valid', {
            deptId: window.sessionStorage.getItem('deptId'),
            plat: 1,
            voucherCode: this.redeemMap.form.voucherCode,
            vailType: 2
          })
          this.loading = false
          if (res.code === 200) {
            window.onkeydown = null

            if (document.activeElement && document.activeElement.blur) {
              document.activeElement.blur();
            }

            this.confirmMap.name = res.data.dealTitle
            this.confirmMap.visible = true
          }
        }
      },
      confirmClose () {
        this.confirmMap.visible = false
      },
      async confirmSubmit () {
        const res = await req.post('/physio/group-voucher/consume', {
          deptId: window.sessionStorage.getItem('deptId'),
          plat: 1,
          registeredId: this.redeemMap.form.registeredId,
          voucherCode: this.redeemMap.form.voucherCode,
          consumeCount: 1
        })
        if (res.code === 200) {
          this.$message.success('验券成功')
          this.confirmClose()
          this.close()
          this.$emit('submit')
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .redeem {}

  .redeem_dialog /deep/ .el-dialog__header {
    display: block;
    padding: 12px 24px !important;
  }

  .redeem_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #1F2329;
  }

  .redeem_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .redeem_dialog /deep/ .el-dialog__body {
    padding: 24px 24px !important;
  }

  .redeem_dialog /deep/ .el-dialog__footer {
    padding: 16px;
  }

  .form_item /deep/ .el-form-item__label {
    line-height: 32px;
  }

  .form_item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_item_code {
    margin: 0 0 0 0;
  }

  .form_input /deep/ .el-input-group__append {
    padding: 0;
    min-height: 0px;
  }

  .form_input_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 30px;
    cursor: pointer;
    user-select: none;
  }

  .form_input_btn.can_click {
    color: #409eff;
    background-color: #ecf5ff;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__header {
    display: block;
    padding: 12px 24px !important;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #1F2329;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__footer {
    padding: 16px;
  }

  .confirm_tips {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 18px;
    width: 100%;
    height: 38px;
    background-color: #FFFBE8;
  }

  .confirm_tips_icon {
    font-size: 16px;
    color: #FE8F1F;
  }

  .confirm_tips_text {
    margin: 0 0 0 5px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .confirm_info {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .confirm_title {
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }
</style>
